var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"taco-img",class:'taco-rating-' + _vm.data.value}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("& Up")])])
}
var staticRenderFns = []

export { render, staticRenderFns }